/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const reserveSectionShortSchema = z.object({
	id: z.uuid(),
	name: z.string().max(100),
});
